import { UiPricingPlanModel } from "../../models";

export function mockUiPricingPlanModel({
    id = "pricing-plan-1234",
    type = "uiPricingPlan",
    locale = "en",
    content = mockUiPricingPlanModelContent()
}: Partial<UiPricingPlanModel> = {}): UiPricingPlanModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiPricingPlanModelContent = UiPricingPlanModel["content"];

export function mockUiPricingPlanModelContent({
    title = "Example pricing plan",
    highlight = false,
    ...optionals
}: Partial<UiPricingPlanModelContent> = {}): UiPricingPlanModelContent {
    return {
        title,
        highlight,
        ...optionals
    };
}
